module.exports = __webpack_public_path__ + "static/lips-after-54c37dac4c6759a3a1a0949a530c7cf8.jpg";